import { ArrowRight } from '@outdoor-voices/ui';
import PropTypes from 'prop-types';
import css from './MissionStatement.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var STICKER_CLASS = 'doing-things-sticker';

var replaceStickerTags = function replaceStickerTags(htmlStr) {
  var htmlObject = document.createElement('div');
  htmlObject.innerHTML = htmlStr;
  var stickers = htmlObject.querySelectorAll(".".concat(STICKER_CLASS));
  stickers.forEach(function (sticker) {
    sticker.classList.add(css[STICKER_CLASS]);
  });
  return htmlObject.innerHTML;
};

var MissionStatement = function MissionStatement(_ref) {
  var blocks = _ref.blocks;
  var _blocks$edges$0$node = blocks.edges[0].node,
      cta = _blocks$edges$0$node.cta,
      rawHtml = _blocks$edges$0$node.rawHtml,
      url = _blocks$edges$0$node.url;
  return /*#__PURE__*/_jsxs("section", {
    className: css.root,
    children: [/*#__PURE__*/_jsx("div", {
      dangerouslySetInnerHTML: {
        __html: replaceStickerTags(rawHtml)
      },
      className: css.blurb
    }), /*#__PURE__*/_jsxs("a", {
      className: css.cta,
      href: url,
      children: [cta, /*#__PURE__*/_jsx(ArrowRight, {})]
    })]
  });
};

MissionStatement.propTypes = {
  blocks: PropTypes.shape({
    edges: PropTypes.arrayOf(PropTypes.shape({
      node: PropTypes.shape({
        cta: PropTypes.string.isRequired,
        rawHtml: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired
      }).isRequired
    })).isRequired
  }).isRequired
};
export default MissionStatement;